export const CARD_TYPES = [
  {
    mask: '0000 0000 0000 0000',
    regex: '^9051\\d{0,12}',
    type: 'arca',
  },
  {
    mask: '0000 0000 0000 0000',
    regex: '^4\\d{0,15}',
    type: 'visa',
  },
  {
    mask: '0000 0000 0000 0000',
    regex: '^(5[1-5]\\d{0,2}|22[2-9]\\d{0,1}|2[3-7]\\d{0,2})\\d{0,12}',
    type: 'mastercard',
  },
  {
    mask: '0000 000000 00000',
    regex: '^3[47]\\d{0,13}',
    type: 'amex',
  },
  {
    mask: '0000 000000 0000',
    regex: '^3(?:0([0-5]|9)|[689]\\d?)\\d{0,11}',
    type: 'diners',
  },
  {
    mask: '0000-0000-0000-0000',
    regex: '^220[0-4]\\d{0,12}',
    type: 'mir',
  },
  {
    mask: '0000 000000 00000',
    regex: '^(?:2131|1800)\\d{0,11}',
    type: 'jcb15',
  },
  {
    mask: '0000 0000 0000 0000',
    regex: '^(?:35\\d{0,2})\\d{0,12}',
    type: 'jcb',
  },
  {
    mask: '0000 0000 0000 0000',
    type: 'unknown',
  }];

export const CARD_ACTION_TYPES = {
  MAKE_DEFAULT: 'makeDefault',
  DELETE: 'delete',
};
